// @ts-nocheck

import Quill from 'quill';
import "./index.less";
const ATTRIBUTES = ['alt', 'height', 'width'];
export default class ImageModule {
  constructor(quill, options = {}) {
    this.quill = quill;
    this.options = options;
    this.img = null;
    this.quill.container.classList.add('image-module');
    document.addEventListener('click', this.handleImg);
    document.addEventListener('copy', this.onCopy, true);
    document.addEventListener('keydown', e => {
      if (this.img && e.keyCode === 8) {
        e.stopPropagation();
        e.preventDefault();
        this.img.remove();
        this.hide();
      }
    }, true);
    this.quill.root.addEventListener('input', this.hide, true);
  }
  onCopy = e => {
    if (!this.img) return;
    // 如果选中了图片，那么select这张图片
    const blot = Quill.find(this.img);
    const index = this.quill.getIndex(blot);
    this.quill.setSelection(index, 1);
  };
  handleImg = e => {
    // 1. 点击在root内的图片 show/review
    // 2. 其他 hide

    if (e.target && e.target.tagName && e.target.tagName.toUpperCase() === 'IMG' && this.quill.root.contains(e.target)) {
      if (this.img === e.target) {
        this.review();
      } else {
        this.show(e.target);
      }
    } else {
      this.hide();
    }
  };
  review = () => {
    if (this.options.onPreview) {
      this.options.onPreview(this.img.getAttribute('src'));
    }
  };
  show = target => {
    this.hide();
    this.img = target;
    this.img.classList.add('focus');
    this.showOverlay();
  };
  showOverlay = () => {
    this.overlay = document.createElement('div');
    this.quill.root.parentNode.appendChild(this.overlay);
    this.repositionOverlay();
    this.overlay.addEventListener('mousedown', this.handleMousedown, true);
  };
  repositionOverlay = () => {
    const parent = this.quill.root.parentNode;
    const imgRect = this.img.getBoundingClientRect();
    const containerRect = parent.getBoundingClientRect();
    const left = imgRect.left - containerRect.left - 1 + parent.scrollLeft + imgRect.width - 16 / 2;
    const top = imgRect.top - containerRect.top + parent.scrollTop + imgRect.height - 16 / 2;
    Object.assign(this.overlay.style, {
      left: left + 'px',
      top: top + 'px',
      width: '16px',
      height: '16px',
      position: 'absolute',
      backgroundColor: '#3370ff',
      border: '2px solid #fff',
      borderRadius: '8px',
      cursor: 'nwse-resize',
      userSelect: 'none',
      zIndex: '1'
    });
  };
  handleMousedown = e => {
    e.stopPropagation();

    // mousedown时，fix下一次的onclick触发
    document.addEventListener('click', e => {
      e.stopPropagation();
    }, {
      capture: true,
      once: true
    });
    this.dragStartX = e.clientX;
    this.preDragWidth = this.img.width || this.img.naturalWidth;
    document.addEventListener('mousemove', this.onResize);
    document.addEventListener('mouseup', this.handleMouseup);
  };
  handleMouseup = () => {
    document.removeEventListener('mousemove', this.onResize);
    document.removeEventListener('mouseup', this.handleMouseup);
  };
  onResize = e => {
    if (!this.img) return;
    const deltaX = e.clientX - this.dragStartX;
    this.img.style.width = Math.round(this.preDragWidth + deltaX) + 'px';
    this.repositionOverlay();
  };
  hide = () => {
    if (this.img) {
      this.img.classList.remove('focus');
      this.img = null;
    }
    if (this.overlay) {
      this.overlay.removeEventListener('mousedown', this.handleMousedown, true);
      this.overlay.remove();
    }
  };
}